export default "__VITE_ASSET__DoDOa6Nf__"